import "./ConfirmModal.scss"

import { Modal } from "@shopify/polaris"
// import { useCallbackWithLoading } from "polaris-enhance"
import { useState } from "react"
export interface ConfirmModalProps {
  open: boolean
  onClose: () => void
  onCancel?: () => void
  onConfirm: (data?: any) => Promise<any> | any
  children: any
  title?: any
  disabledConfirm?: boolean
  confirmText?: string
  cancelText?: string
  destructiveConfirm?: boolean
  autoClose?: boolean
  noScroll?: boolean
  limitHeight?: boolean
  delayed?: boolean
  loading?: boolean
  hideActions?: boolean
}
const ConfirmModal = (props: ConfirmModalProps) => {
  const {
    onClose,
    onCancel,
    open,
    onConfirm,
    autoClose,
    children,
    title,
    disabledConfirm = false,
    limitHeight = false,
    confirmText = t("Confirm"),
    destructiveConfirm,
    cancelText,
    noScroll = false,
    delayed = false,
    loading = false,
    hideActions = false,
  } = props

  const [loadingModal, setLoadingModal] = useState(false)

  // const [loading, handleConfirm] = useCallbackWithLoading(async () => {
  //   await onConfirm()
  //   autoClose && onClose()
  // }, [onConfirm, autoClose])

  const handleConfirm = async () => {
    setLoadingModal(true)
    await onConfirm()
    if (delayed) {
      setTimeout(() => {
        setLoadingModal(false)
        autoClose && onClose()
      }, 3000) // 延迟三秒
    } else {
      setLoadingModal(false)
      autoClose && onClose()
    }
  }

  return (
    <Modal
      open={open}
      // 产品需要不能关闭弹窗
      onClose={() => onClose()}
      title={title}
      limitHeight={limitHeight}
      noScroll={noScroll}
      primaryAction={
        hideActions
          ? undefined
          : {
              content: confirmText,
              onAction: handleConfirm,
              disabled: disabledConfirm,
              destructive: destructiveConfirm,
              loading: loadingModal || loading,
            }
      }
      secondaryActions={
        hideActions
          ? undefined
          : [
              {
                content: cancelText || t("Cancel"),
                onAction: () => {
                  onCancel?.()
                  onClose()
                },
              },
            ]
      }
    >
      {/* 这里将Modal.Section去掉 让使用者传递内容 不限制一个Section 提高自由度 */}
      {children}
    </Modal>
  )
}

export default ConfirmModal
